export const VUEX_LOCALSTORAGE_INIT = 'VUEX_LOCALSTORAGE_INIT'

export const VUEX_LOCALSTORAGE_SET_STATE = 'VUEX_LOCALSTORAGE_SET_STATE'
export const VUEX_LOCALSTORAGE_DATA_SET = 'VUEX_LOCALSTORAGE_DATA_SET'
export const VUEX_LOCALSTORAGE_DATA_REMOVE = 'VUEX_LOCALSTORAGE_DATA_REMOVE'

export const VUEX_LOCALSTORAGE_REFRESH_STATE = 'VUEX_LOCALSTORAGE_REFRESH_STATE'
export const VUEX_LOCALSTORAGE_CLEAR = 'VUEX_LOCALSTORAGE_CLEAR'
